import React from 'react'

export const Loading = () => {
  return (
    <div class="o-pokeball c-loader u-flip"></div>
  )
}
